import { render } from "./Dumping_Ground_stop_master.vue?vue&type=template&id=537891c1&scoped=true"
import script from "./Dumping_Ground_stop_master.vue?vue&type=script&lang=js"
export * from "./Dumping_Ground_stop_master.vue?vue&type=script&lang=js"

import "./Dumping_Ground_stop_master.vue?vue&type=style&index=0&id=537891c1&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\MAHASBM\\MAHASBM-CODE\\ui-code\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-537891c1"]])

export default __exports__